const IconCheckmarkCircled = (): JSX.Element => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m21.596 5.789 -0.273 -0.417 -9.969 8.448 -3.723 -4.721 -2.637 2.084 3.759 4.766 -0.026 0.017 0.637 0.756 0.558 0.707 0.277 0.343 0.031 -0.021 0.453 0.536 9.868 -8.338q0.237 1.004 0.237 2.053c0 2.347 -0.915 4.558 -2.576 6.215a8.734 8.734 0 0 1 -6.215 2.576 8.726 8.726 0 0 1 -6.216 -2.576 8.743 8.743 0 0 1 -2.571 -6.215c0 -2.347 0.915 -4.558 2.577 -6.215a8.726 8.726 0 0 1 6.214 -2.576c1.724 0 3.368 0.492 4.774 1.406l2.092 -1.754a11.143 11.143 0 0 0 -2.211 -1.301A11.314 11.314 0 0 0 12 0.572a11.357 11.357 0 0 0 -8.083 3.345A11.357 11.357 0 0 0 0.571 12c0 3.055 1.186 5.925 3.345 8.083A11.357 11.357 0 0 0 12 23.429c3.056 0 5.926 -1.186 8.085 -3.345A11.357 11.357 0 0 0 23.428 12c0 -2.216 -0.633 -4.36 -1.833 -6.211"
        fill="currentColor"
      />
    </>
  );
};

export default IconCheckmarkCircled;
